// frontend/src/api.js
import axios from 'axios';

// Base URL comes from the environment so dev / staging / prod differ only by config.
// Set REACT_APP_API_BASE_URL in frontend/.env (see frontend/.env.example).
// Empty string -> same origin (works with the CRA "proxy" setting in development).
const baseURL = process.env.REACT_APP_API_BASE_URL || '';

const apiClient = axios.create({ baseURL });

apiClient.interceptors.request.use(
    (config) => {
        const authTokens = localStorage.getItem('authTokens');
        if (authTokens) {
            try {
                const token = JSON.parse(authTokens).access;
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } catch (e) {
                localStorage.removeItem('authTokens');
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default apiClient;
